import _get from "lodash/get";
import React, { useContext, useState, useEffect } from 'react';
import { ThemeContext } from 'styled-components';
import withSizes from 'react-sizes';
import { Carousel } from '~carousel';
import { layoutTheme, isSizes } from '~layout';
import { BackdropImage, helpersPropTypes } from '~helpers';
import CarouselContainer from './CarouselContainer';
import ImageContainer from './ImageContainer';

var HeroCarousel = function HeroCarousel(_ref) {
  var imageHeight = _ref.imageHeight,
      imageWidth = _ref.imageWidth,
      carouselImageSet = _ref.carouselImageSet,
      viewportHeight = _ref.viewportHeight,
      viewportWidth = _ref.viewportWidth,
      isMobile = _ref.isMobile,
      showDivider = _ref.showDivider,
      backgroundColor = _ref.backgroundColor;
  var theme = useContext(ThemeContext);

  var _useState = useState(false),
      checkIsMobile = _useState[0],
      setIsMobile = _useState[1];

  var _useState2 = useState(),
      checkViewportHeight = _useState2[0],
      setViewportHeight = _useState2[1];

  var _useState3 = useState(),
      checkViewportWidth = _useState3[0],
      setViewportWidth = _useState3[1];

  var _useState4 = useState(),
      checkImageHeight = _useState4[0],
      setCheckImageHeight = _useState4[1];

  var backgroundStyles = {
    maxWidth: imageWidth,
    overflow: 'hidden'
  };
  useEffect(function () {
    setIsMobile(isMobile);
  }, [isMobile]);
  useEffect(function () {
    setViewportWidth(viewportWidth);
  }, [viewportWidth]);
  useEffect(function () {
    setViewportHeight(function (prevState) {
      // handle browsers hiding and showing the address bar on swipe up and down
      // portrait orientation, mobile and has previous state
      if (viewportWidth < viewportHeight && prevState && isMobile) {
        return Math.max(prevState, viewportHeight);
      }

      if (viewportWidth > viewportHeight && prevState && isMobile) {
        return Math.max(prevState, viewportWidth);
      }

      return viewportHeight;
    });
  }, [viewportWidth, viewportHeight, checkViewportWidth, isMobile]);
  useEffect(function () {
    setCheckImageHeight(isMobile ? checkViewportHeight * 0.7 : _get(theme, 'layout.media.sm', layoutTheme.layout.media.sm));
  }, [isMobile, checkViewportHeight, checkViewportWidth, theme]);

  var handleImageWidth = _get(theme, 'layout.media.sm', layoutTheme.layout.media.sm);

  var carouselSettings = {
    dots: true,
    infinite: true,
    arrows: false,
    dotsOrientation: 'horizontal',
    dotsPosition: 'inside bottom',
    dotsAlignment: 'center',
    slidesToShow: 2,
    responsive: [{
      breakpoint: _get(theme, 'layout.media.lg', layoutTheme.layout.media.lg) - 1,
      settings: {
        dots: true,
        dotsOrientation: 'horizontal',
        slidesToShow: 1
      }
    }, {
      breakpoint: _get(theme, 'layout.media.md', layoutTheme.layout.media.md) - 1,
      settings: {
        dots: true,
        dotsOrientation: 'horizontal',
        slidesToShow: 1
      }
    }, {
      breakpoint: _get(theme, 'layout.media.sm', layoutTheme.layout.media.sm) - 1,
      settings: {
        dots: true,
        dotsOrientation: 'horizontal',
        slidesToShow: 1
      }
    }, {
      breakpoint: _get(theme, 'layout.media.sm', layoutTheme.layout.media.xs) - 1,
      settings: {
        dots: true,
        dotsOrientation: 'vertical',
        slidesToShow: 1
      }
    }]
  };
  return /*#__PURE__*/React.createElement(CarouselContainer, {
    imageHeight: imageHeight || checkImageHeight,
    imageWidth: imageWidth || handleImageWidth,
    viewportHeight: checkViewportHeight,
    viewportWidth: checkViewportWidth,
    isMobile: checkIsMobile,
    backgroundColor: backgroundColor,
    showDivider: showDivider,
    imagesToShow: carouselSettings.slidesToShow
  }, /*#__PURE__*/React.createElement(Carousel, carouselSettings, carouselImageSet && carouselImageSet.map(function (image, imageIndex) {
    return /*#__PURE__*/React.createElement(BackdropImage, {
      key: imageIndex,
      fluid: image,
      backgroundColor: backgroundColor,
      style: backgroundStyles
    }, /*#__PURE__*/React.createElement(ImageContainer, {
      isMobile: checkIsMobile,
      imageHeight: imageHeight || checkImageHeight,
      imageWidth: imageWidth || handleImageWidth,
      viewportHeight: checkViewportHeight,
      viewportWidth: checkViewportWidth,
      backgroundColor: backgroundColor
    }));
  })));
};

HeroCarousel.defaultProps = {
  isMobile: false,
  viewportHeight: undefined,
  viewportWidth: undefined,
  showDivider: false,
  imageHeight: undefined,
  imageWidth: undefined
};

var mapSizesToProps = function mapSizesToProps(_ref2, _ref3) {
  var width = _ref2.width,
      height = _ref2.height;
  var theme = _ref3.theme;
  return {
    isMobile: isSizes.xsView({
      width: width
    }, {
      theme: theme
    }),
    viewportHeight: height,
    viewportWidth: width
  };
};

export default withSizes(mapSizesToProps)(HeroCarousel);